const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export const formatCurrency = (amount: number): string => CURRENCY_FORMATTER.format(amount)

const CURRENCY_WITH_CENTS_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// Always shows two decimals, e.g. `$1,234.50`, for amounts listed in tables and summaries.
export const formatCurrencyWithCents = (value: number): string => CURRENCY_WITH_CENTS_FORMATTER.format(value)
